export default "__VITE_ASSET__DPPQAR0p__"